/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import Model from "../../components/store/Model";
import Model2 from "../../components/store/Model2";
import Model3 from "../../components/store/Model3";
import { doc } from "firebase/firestore";
import apicache from "../../components/clearCach/clear";
import { db } from "../../firebase";
import ImageCompressor from "react-image-file-resizer";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useLocation } from "react-router-dom";
import { FileText } from "lucide-react";
import axios from "axios";
import {
  Palette,
  Store as StoreIcon,
  Layers,
  Image as ImageIcon,
  LayoutGrid,
  Type,
  Megaphone,
  Upload,
  X,
  Save,
  CreditCard,
  RefreshCw,
  Lightbulb,
  Plus,
  Trash2,
} from "lucide-react";
import { Button as AntButton, Tabs as AntTabs } from "antd";

function Store() {
  const { t, i18n } = useTranslation();
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useStoreFormDraft(store);
  const products = useSelector((state) => state.ProductsReducer);
  const { TabPane } = AntTabs;
  const isRTL = i18n.language === "ar";

  const [show, setShow] = useState({
    model1: false,
    model2: false,
    model3: false,
  });

  const [show2, setShow2] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");

  const message = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-purple mx-2",
        cancelButton: "btn btn-gray mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: `<a href="https://m.me/F0orweb" target="_blank">${t(
          "settings.contact_for_trial"
        )}</a>`,
        showCancelButton: true,
        confirmButtonText: t("common.yes"),
        cancelButtonText: t("common.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
      });
  };

  const uploadImage2 = async (e, type, index) => {
    setLoading(true);
    for (let i = 0; i < e.length; i++) {
      await ImageCompressor.imageFileResizer(
        e[i],
        Infinity,
        Infinity,
        "WEBP",
        80,
        0,
        async (uri) => {
          const dataImage = new FormData();
          const blob = await fetch(uri).then((r) => r.blob());
          dataImage.append("upload", blob, new Date().getTime() + i + "main");

          axios
            .post(
              `https://octopus-app-i4ylg.ondigitalocean.app/upload`,
              dataImage,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then(function (response) {
              setLoading(false);
              if (type === "main") {
                setData((prev) => ({ ...prev, img: response.data.url }));
              }
              if (type === "logo") {
                setData((prev) => ({ ...prev, logo: response.data.url }));
              }
              if (type === "cate") {
                setData((prev) => ({
                  ...prev,
                  categories: update(prev.categories, response.data.url, index),
                }));
              }
              if (type === "slider1") {
                setData((prev) => ({
                  ...prev,
                  slider: { ...prev.slider, img1: response.data.url },
                }));
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        },
        "base64"
      );
    }
  };

  const handleDropAdditional = (e, index) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      uploadAdditionalImage([files[0]], index);
    }
  };

  const uploadAdditionalImage = async (e, index) => {
    setLoading(true);
    for (let i = 0; i < e.length; i++) {
      await ImageCompressor.imageFileResizer(
        e[i],
        Infinity,
        Infinity,
        "WEBP",
        80,
        0,
        async (uri) => {
          const dataImage = new FormData();
          const blob = await fetch(uri).then((r) => r.blob());
          dataImage.append(
            "upload",
            blob,
            new Date().getTime() + i + "additional"
          );

          axios
            .post(
              `https://octopus-app-i4ylg.ondigitalocean.app/upload`,
              dataImage,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then(function (response) {
              setLoading(false);
              setData((prev) => {
                const updatedAdditionalCategories = [
                  ...(prev.additionalCategories || []),
                ];
                updatedAdditionalCategories[index] = {
                  ...updatedAdditionalCategories[index],
                  image: response.data.url,
                };
                return {
                  ...prev,
                  additionalCategories: updatedAdditionalCategories,
                };
              });
            })
            .catch(function (error) {
              setLoading(false);
              console.log(error);
            });
        },
        "base64" // output type
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    apicache(account, products);
    setLoading(true);

    const whiteColors = [
      "#ffffff",
      "#fff",
      "#fefefe",
      "#f5f5f5",
      "#fafafa",
      "#fcfcfc",
      "#f0f0f0",
      "#eeeeee",
      "#f8f8f8",
      "#f7f7f7",
      "#f4f4f4",
      "#f9f9f9",
      "#efefef",
      "#f9f9fb",
      "#c0c0c0",
    ];

    if (whiteColors.includes(data.color1.toLowerCase())) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: t("error"),
        text: t("settings.white_color_error"),
        confirmButtonText: t("ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return;
    }

    const updateData = {
      ...data,
      additionalCategories: data.additionalCategories || [],
    };

    try {
      await saveStoreDraft(doc(db, "store", data.id), store, updateData);
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: t("settings.success"),
        confirmButtonText: t("ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      Swal.fire({ icon: "error", title: t("ui.notSaved"), confirmButtonText: t("ship.ok") });
    } finally {
      setLoading(false);
    }
  };

  function update(array, newItem, atIndex) {
    return array.map((item, index) => (index === atIndex ? newItem : item));
  }

  const onClickHandler = (n) => {
    const arr = [...data.categories];
    arr[n] = "";
    setData({ ...data, categories: arr });
  };

  const [showSideBar, setShowSideBar] = useState(true);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [image, setImage] = useState(null);

  const handleImageUpload = (file) => {
    setImage(URL.createObjectURL(file));
    uploadImage2([file], "main");
  };

  const handleFileChange = (e) => {
    handleImageUpload(e.target.files[0]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleImageUpload(e.dataTransfer.files[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleImageUpload1 = (file) => {
    setImage(URL.createObjectURL(file));
    uploadImage2([file], "logo");
  };

  const handleFileChange1 = (e) => {
    handleImageUpload1(e.target.files[0]);
  };

  const handleDrop1 = (e) => {
    e.preventDefault();
    handleImageUpload1(e.dataTransfer.files[0]);
  };

  const handleDragOver1 = (e) => {
    e.preventDefault();
  };

  const handleImageUpload2 = (file) => {
    setImage(URL.createObjectURL(file));
    uploadImage2([file], "slider1");
  };

  const handleFileChange2 = (e) => {
    handleImageUpload2(e.target.files[0]);
  };

  const handleDrop2 = (e) => {
    e.preventDefault();
    handleImageUpload2(e.dataTransfer.files[0]);
  };

  const handleDragOver2 = (e) => {
    e.preventDefault();
  };
  const activateTheme = async (themeNumber) => {
    if (!account.store) {
      message();
      return;
    }

    const result = await Swal.fire({
      title: t("ui.themeActivationConfirm"),
      text: t("ui.activateThemeNumber", { value0: (themeNumber) }),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("ui.yesActivate"),
      cancelButtonText: t("annule"),
      confirmButtonColor: "#9b59bf",
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      // تحديث الوثيقة مباشرة
      await saveStoreDraft(doc(db, "store", data.id), store, {
          ...data,
          theme: themeNumber,
        });

      // نحدّث الstate محليا
      setData((prev) => ({
        ...prev,
        theme: themeNumber,
      }));

      Swal.fire({
        icon: "success",
        title: t("ui.themeActivated"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: t("Products.ImportModal.error"),
        text: t("ui.themeNotActivated"),
      });
    } finally {
      setLoading(false);
    }
  };

  function hexToRgba(hex, alpha = 1) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      setActiveTab(tab);
    }
  }, [location]);

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba]  mb-1">
                  {t("settings.store_settings")}
                </h2>
                <p className="text-gray-600 mb-0 dark:text-gray-200">
                  {t("settings.customize_appearance")}
                </p>
              </div>
              <div className="flex flex-row items-center gap-x-4">
                <div className="opacity-0 flex items-center gap-3">
                  <select className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg p-2.5 focus:ring-purple-200 focus:border-purple-500">
                    <option value={5}>
                      {t("settings.products", { count: 5 })}
                    </option>
                    <option value={10}>
                      {t("settings.products", { count: 10 })}
                    </option>
                    <option value={25}>
                      {t("settings.products", { count: 25 })}
                    </option>
                    <option value={50}>
                      {t("settings.products", { count: 50 })}
                    </option>
                    <option value={100}>
                      {t("settings.products", { count: 100 })}
                    </option>
                  </select>
                </div>
                <button
                  onClick={!!account.store ? handleSubmit : message}
                  className="w-full bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center"
                >
                  <Save size={18} />
                  <span className="mr-2">{t("settings.save_changes")}</span>
                </button>
              </div>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white rounded-xl shadow-sm border border-[#fbf4ff] overflow-hidden dark:!border-[#3c3a3d] dark:!bg-[#181819]">
              <div className="flex">
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab1"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab1")}
                >
                  {t("settings.store_identity")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab2"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab2")}
                >
                  {t("settings.categories")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab3"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab3")}
                >
                  {t("settings.thank_you_page")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab4"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab4")}
                >
                  {t("settings.store_themes")}
                </button>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="mx-3 mb-6">
            {/* Store Identity Tab */}
            {activeTab === "tab1" && data && (
              <div className="space-y-6">
                {account.productMode === "digital" && (
                  <>
                    {/* Description Section */}
                    <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                      <div className="flex items-center mb-4 gap-x-2">
                        <FileText size={20} className="text-[#9e68ba] mr-2" />
                        <h3 className="text-lg font-semibold text-gray-800 dark:!text-[#9e68ba]">
                          {t("settings.digitalStore.descriptionSection.title")}
                        </h3>
                        <span className="text-sm text-gray-500 mr-3 dark:!text-gray-400">
                          {t(
                            "settings.digitalStore.descriptionSection.subtitle"
                          )}
                        </span>
                      </div>

                      <div className="grid grid-cols-1 gap-6">
                        <div>
                          <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                            {t(
                              "settings.digitalStore.descriptionSection.fields.digitalProductsDescription.label"
                            )}
                          </label>
                          <textarea
                            value={data.digitalProductsDescription || ""}
                            onChange={(e) =>
                              setData({
                                ...data,
                                digitalProductsDescription: e.target.value,
                              })
                            }
                            rows={6}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 resize-vertical dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                            placeholder={t(
                              "settings.digitalStore.descriptionSection.fields.digitalProductsDescription.placeholder"
                            )}
                          />
                          <div className="flex justify-between items-center mt-2">
                            <span className="text-xs text-gray-400">
                              {data.digitalProductsDescription?.length || 0}
                              {t(
                                "settings.digitalStore.descriptionSection.fields.digitalProductsDescription.charCount"
                              )}
                            </span>
                            <span className="text-xs text-gray-500 dark:!text-gray-400">
                              {t(
                                "settings.digitalStore.descriptionSection.fields.digitalProductsDescription.hint"
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Info Section */}
                    <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                      <div className="flex items-center mb-4 gap-x-2">
                        <FileText size={20} className="text-[#9e68ba] mr-2" />
                        <h3 className="text-lg font-semibold text-gray-800 dark:!text-[#9e68ba]">
                          {t("settings.digitalStore.infoSection.title")}
                        </h3>
                        <span className="text-sm text-gray-500 mr-3 dark:!text-gray-400">
                          {t("settings.digitalStore.infoSection.subtitle")}
                        </span>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                        {/* Specialty */}
                        <div>
                          <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                            {t(
                              "settings.digitalStore.infoSection.fields.specialty.label"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={t(
                              "settings.digitalStore.infoSection.fields.specialty.placeholder"
                            )}
                            value={data?.texting?.specialty}
                            onChange={(e) =>
                              setData({
                                ...data,
                                texting: {
                                  ...data.texting,
                                  specialty: e.target.value,
                                },
                              })
                            }
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          />
                        </div>

                        {/* Town */}
                        <div>
                          <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                            {t(
                              "settings.digitalStore.infoSection.fields.town.label"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={t(
                              "settings.digitalStore.infoSection.fields.town.placeholder"
                            )}
                            value={data?.texting?.town}
                            onChange={(e) =>
                              setData({
                                ...data,
                                texting: {
                                  ...data.texting,
                                  town: e.target.value,
                                },
                              })
                            }
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          />
                        </div>

                        {/* Note */}
                        <div>
                          <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                            {t(
                              "settings.digitalStore.infoSection.fields.note.label"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={t(
                              "settings.digitalStore.infoSection.fields.note.placeholder"
                            )}
                            value={data?.texting?.note}
                            onChange={(e) =>
                              setData({
                                ...data,
                                texting: {
                                  ...data.texting,
                                  note: e.target.value,
                                },
                              })
                            }
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Colors Section */}
                <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <div className="flex items-center mb-4 gap-x-2">
                    <Palette size={20} className="text-[#9e68ba] mr-2" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-[#9e68ba]">
                      {t("settings.colors")}
                    </h3>
                    <span className="text-sm text-gray-500 mr-3 dark:text-gray-400">
                      {t("settings.avoid_white_color")}
                    </span>
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="col-span-2">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                            {t("settings.primary_color")}
                          </label>
                          <div className="flex">
                            <input
                              type="text"
                              value={data.color1}
                              onChange={(e) =>
                                setData({ ...data, color1: e.target.value })
                              }
                              className="flex-grow rounded-r-none px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#181819] dark:text-gray-400 dark:!border-[#3c3a3d]"
                              placeholder={t("settings.enter_color_code")}
                            />
                            <input
                              type="color"
                              value={data.color1}
                              onChange={(e) =>
                                setData({ ...data, color1: e.target.value })
                              }
                              className="w-12 h-10 rounded-l-none border border-gray-300 dark:!border-[#3c3a3d] border-r-0 rounded-lg cursor-pointer"
                            />
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                            {t("settings.secondary_color")}
                          </label>
                          <div className="flex">
                            <input
                              type="text"
                              value={data.color2}
                              onChange={(e) =>
                                setData({ ...data, color2: e.target.value })
                              }
                              className="flex-grow rounded-r-none px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#181819] dark:text-gray-400 dark:!border-[#3c3a3d]"
                              placeholder={t("settings.enter_color_code")}
                            />
                            <input
                              type="color"
                              value={data.color2}
                              onChange={(e) =>
                                setData({ ...data, color2: e.target.value })
                              }
                              className="w-12 h-10 rounded-l-none border border-gray-300 border-r-0 rounded-lg cursor-pointer dark:!border-[#3c3a3d]"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-center items-center">
                      <svg
                        width="180"
                        height="239"
                        viewBox="0 0 180 239"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-48 h-64"
                      >
                        <rect
                          x="1.56572"
                          y="1.38158"
                          width="176.869"
                          height="236.237"
                          rx="10.5132"
                          fill="#F3F3F3"
                          stroke="#E9E9E9"
                          strokeWidth="1.23684"
                        ></rect>
                        <rect
                          x="3.1052"
                          y="2.1052"
                          width="172.7393"
                          height="6.18421"
                          rx="3.09211"
                          fill={data.color1}
                        ></rect>
                        <rect
                          x="78.184"
                          y="13.6055"
                          width="24.7369"
                          height="8.6579"
                          rx="4.32895"
                          fill="#C4C4C4"
                        ></rect>
                        <rect
                          x="10.842"
                          y="194.948"
                          width="18.7393"
                          height="6.18421"
                          rx="3.09211"
                          fill={data.color1}
                        ></rect>
                        <rect
                          x="30.6315"
                          y="194.948"
                          width="18.7393"
                          height="6.18421"
                          rx="3.09211"
                          fill={data.color2}
                        ></rect>
                        <rect
                          x="64.8421"
                          y="28.3159"
                          width="51.1316"
                          height="2.47369"
                          rx="1.23684"
                          fill={data.color1}
                        ></rect>
                        <rect
                          x="134.1578"
                          y="177.3159"
                          width="11.1316"
                          height="2.47369"
                          rx="1.23684"
                          fill={data.color2}
                        ></rect>
                        <rect
                          x="83.1578"
                          y="177.3159"
                          width="11.1316"
                          height="2.47369"
                          rx="1.23684"
                          fill={data.color2}
                        ></rect>
                        <rect
                          x="30.1578"
                          y="177.3159"
                          width="11.1316"
                          height="2.47369"
                          rx="1.23684"
                          fill={data.color2}
                        ></rect>
                        <circle
                          cx="161.6767"
                          cy="225.5525"
                          r="2.47369"
                          fill="#C4C4C4"
                        ></circle>
                        <circle
                          cx="154.6767"
                          cy="225.5525"
                          r="2.47369"
                          fill="#C4C4C4"
                        ></circle>
                        <rect
                          x="10.842"
                          y="35.3948"
                          width="157.079"
                          height="81.6316"
                          rx="4.94737"
                          fill="#C4C4C4"
                          fillOpacity="0.5"
                        ></rect>
                        <rect
                          x="80.1052"
                          y="227.105"
                          width="18.5526"
                          height="2.47369"
                          fill="#E9E9E9"
                        ></rect>
                        <rect
                          x="11.2368"
                          y="121.974"
                          width="50"
                          height="63"
                          rx="4.94737"
                          fill="#C4C4C4"
                          fillOpacity="0.5"
                        ></rect>
                        <rect
                          x="118.2368"
                          y="121.974"
                          width="50"
                          height="63"
                          rx="4.94737"
                          fill="#C4C4C4"
                          fillOpacity="0.5"
                        ></rect>
                        <rect
                          x="65.2368"
                          y="121.974"
                          width="50"
                          height="63"
                          rx="4.94737"
                          fill="#C4C4C4"
                          fillOpacity="0.5"
                        ></rect>
                        <circle
                          r="1.57416"
                          transform="matrix(1 0 0 -1 97.0837 111.179)"
                          fill="#C4C4C4"
                        ></circle>
                        <circle
                          r="1.57416"
                          transform="matrix(1 0 0 -1 92.3612 111.179)"
                          fill="#C4C4C4"
                        ></circle>
                        <circle
                          r="1.57416"
                          transform="matrix(1 0 0 -1 87.6387 111.179)"
                          fill="#ffffff"
                        ></circle>
                        <circle
                          r="1.57416"
                          transform="matrix(1 0 0 -1 82.9162 111.179)"
                          fill="#C4C4C4"
                        ></circle>
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Store Logo Section */}
                <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <div className="flex items-center mb-4 gap-x-2">
                    <StoreIcon size={20} className="text-[#9e68ba] mr-2" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-[#9e68ba]">
                      {t("settings.store_logo")}
                    </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div>
                      <p className="font-medium text-[#9e68ba] mb-2">
                        {t("settings.specifications")}
                      </p>
                      <ul className="text-sm text-gray-600 dark:!text-gray-400 space-y-1">
                        <li>{t("settings.logo_width")}</li>
                        <li>{t("settings.logo_height")}</li>
                        <li>{t("settings.max_size")}</li>
                        <li>{t("settings.supported_formats")}</li>
                      </ul>
                    </div>

                    <div className="relative">
                      {data.img && (
                        <button
                          onClick={() => setData({ ...data, img: "" })}
                          className="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full p-1 hover:bg-red-200 z-10"
                        >
                          <X size={16} />
                        </button>
                      )}
                      <div
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onClick={() => document.getElementById("logo").click()}
                        className={`flex flex-col items-center justify-center w-40 h-40 mx-auto border-2 border-dashed rounded-xl p-2 cursor-pointer transition-all ${
                          data.img
                            ? "border-purple-300 bg-[#fcf6ff]"
                            : "border-gray-300 hover:border-[#9b59bf]"
                        }`}
                      >
                        {data.img ? (
                          <img
                            src={data.img}
                            alt={t("settings.store_logo")}
                            className="w-24 h-24 object-contain rounded-full"
                          />
                        ) : (
                          <>
                            <Upload className="w-10 h-10 text-[#9e68ba] mb-2" />
                            <span className="text-sm text-gray-500">
                              {t("settings.click_or_drop")}
                            </span>
                          </>
                        )}
                        <input
                          id="logo"
                          type="file"
                          className="hidden"
                          onChange={handleFileChange}
                          accept="image/*"
                        />
                      </div>
                    </div>

                    <div className="flex justify-center items-center">
                      <div className="relative w-64 h-48 rounded-lg overflow-hidden shadow-md">
                        <img
                          src="/image-logo1.png"
                          alt={t("ui.background")}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                          <img
                            src={data.img ? data.img : "/logofoorweb.png"}
                            alt={t("ui.logo")}
                            className="w-20 h-20 object-contain rounded-full bg-white/80 p-2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Store Icon Section */}
                <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <div className="flex items-center mb-4 gap-x-2">
                    <ImageIcon size={20} className="text-[#9e68ba] mr-2" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-[#9e68ba]">
                      {t("settings.store_icon")}
                    </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div>
                      <p className="font-medium text-[#9e68ba] mb-2">
                        {t("settings.specifications")}
                      </p>
                      <ul className="text-sm text-gray-600 dark:!text-gray-400 space-y-1">
                        <li>{t("settings.icon_width")}</li>
                        <li>{t("settings.icon_height")}</li>
                        <li>{t("settings.max_size")}</li>
                        <li>{t("settings.supported_formats")}</li>
                      </ul>
                    </div>

                    <div className="relative">
                      {data.logo && (
                        <button
                          onClick={() => setData({ ...data, logo: "" })}
                          className="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full p-1 hover:bg-red-200 z-10"
                        >
                          <X size={16} />
                        </button>
                      )}
                      <div
                        onDrop={handleDrop1}
                        onDragOver={handleDragOver1}
                        onClick={() => document.getElementById("icon").click()}
                        className={`flex flex-col items-center justify-center w-40 h-40 mx-auto border-2 border-dashed rounded-xl p-2 cursor-pointer transition-all ${
                          data.logo
                            ? "border-purple-300 bg-[#fcf6ff]"
                            : "border-gray-300 hover:border-[#9b59bf]"
                        }`}
                      >
                        {data.logo ? (
                          <img
                            src={data.logo}
                            alt={t("settings.store_icon")}
                            className="w-24 h-24 object-contain rounded-full"
                          />
                        ) : (
                          <>
                            <Upload className="w-10 h-10 text-[#9e68ba] mb-2" />
                            <span className="text-sm text-gray-500">
                              {t("settings.click_or_drop")}
                            </span>
                          </>
                        )}
                        <input
                          id="icon"
                          type="file"
                          className="hidden"
                          onChange={handleFileChange1}
                          accept="image/*"
                        />
                      </div>
                    </div>

                    <div className="flex justify-center items-center">
                      <div className="relative w-64 h-48 rounded-lg overflow-hidden shadow-md">
                        <img
                          src="/image-icon.png"
                          alt={t("ui.background")}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute top-4 right-4">
                          <img
                            src={data.logo ? data.logo : "/logofoorweb.png"}
                            alt={t("ui.logo")}
                            className="w-10 h-10 object-contain rounded-md shadow-md bg-white/90 p-1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Store Announcements Section */}
                <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <div className="flex items-center mb-4 gap-x-2">
                    <Megaphone size={20} className="text-[#9e68ba] mr-2" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-[#9e68ba]">
                      {t("settings.store_announcements")}
                    </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("settings.announcement_1")}
                      </label>
                      <input
                        type="text"
                        placeholder={t("settings.announcement_1")}
                        value={data?.texting?.heading1}
                        onChange={(e) =>
                          setData({
                            ...data,
                            texting: {
                              ...data.texting,
                              heading1: e.target.value,
                            },
                          })
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#181819] dark:text-gray-400 dark:!border-[#3c3a3d]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("settings.announcement_2")}
                      </label>
                      <input
                        type="text"
                        placeholder={t("settings.announcement_2")}
                        value={data?.texting?.heading2}
                        onChange={(e) =>
                          setData({
                            ...data,
                            texting: {
                              ...data.texting,
                              heading2: e.target.value,
                            },
                          })
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#181819] dark:text-gray-400 dark:!border-[#3c3a3d]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("settings.announcement_3")}
                      </label>
                      <input
                        type="text"
                        placeholder={t("settings.announcement_3")}
                        value={data?.texting?.heading3}
                        onChange={(e) =>
                          setData({
                            ...data,
                            texting: {
                              ...data.texting,
                              heading3: e.target.value,
                            },
                          })
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#181819] dark:text-gray-400 dark:!border-[#3c3a3d]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("settings.announcement_4")}
                      </label>
                      <input
                        type="text"
                        placeholder={t("settings.announcement_4")}
                        value={data?.texting?.heading4}
                        onChange={(e) =>
                          setData({
                            ...data,
                            texting: {
                              ...data.texting,
                              heading4: e.target.value,
                            },
                          })
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#181819] dark:text-gray-400 dark:!border-[#3c3a3d]"
                      />
                    </div>
                  </div>

                  <div className="flex justify-center mb-4">
                    <div className="max-w-sm w-full">
                      <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-200">
                        <div
                          style={{ backgroundColor: data.color1 }}
                          className="py-2 text-center text-white"
                        >
                          {data?.texting?.heading1}
                        </div>
                        <div className="p-4">
                          <p className="text-center text-gray-900 font-bold mb-2">
                            {data?.texting?.heading2}
                          </p>
                          <div
                            className="h-1 mx-auto w-16 mb-3"
                            style={{
                              backgroundColor: hexToRgba(data.color1, 0.2),
                            }}
                          ></div>
                          <p className="text-center text-gray-600 text-sm">
                            {data?.texting?.heading3}
                          </p>
                          <div className="flex justify-center mt-4">
                            <img
                              src={data?.logo ? data?.logo : "/logofoorweb.png"}
                              alt={t("ui.logo")}
                              className="w-16 h-16 object-contain rounded-full bg-white p-1 border border-gray-200"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Slider Section */}
                <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <div className="flex items-center mb-4 gap-x-2">
                    <Layers size={20} className="text-[#9e68ba] mr-2" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-[#9e68ba]">
                      {t("settings.slider")}
                    </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div>
                      <p className="font-medium text-[#9e68ba] mb-2">
                        {t("settings.specifications")}
                      </p>
                      <div className="text-sm text-gray-600 dark:!text-gray-400 space-y-1">
                        <p className="font-medium mt-2">
                          {t("settings.desktop_mode")}:
                        </p>
                        <ul className="mr-4">
                          <li>{t("settings.slider_desktop_width")}</li>
                          <li>{t("settings.slider_desktop_height")}</li>
                        </ul>
                        <p className="mt-2">{t("settings.max_size")}</p>
                        <p>{t("settings.supported_formats")}</p>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div className="relative">
                        {data?.slider?.img1 && (
                          <button
                            onClick={() =>
                              setData({
                                ...data,
                                slider: {
                                  ...data.slider,
                                  img1: "",
                                },
                              })
                            }
                            className="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full p-1 hover:bg-red-200 z-10"
                          >
                            <X size={16} />
                          </button>
                        )}
                        <div
                          onDrop={handleDrop2}
                          onDragOver={handleDragOver2}
                          onClick={() =>
                            document.getElementById("slider1").click()
                          }
                          className={`flex flex-col items-center justify-center h-32 mx-auto border-2 border-dashed rounded-xl p-2 cursor-pointer transition-all ${
                            data?.slider?.img1
                              ? "border-purple-300 bg-[#fcf6ff]"
                              : "border-gray-300 hover:border-[#9b59bf]"
                          }`}
                        >
                          {data?.slider?.img1 ? (
                            <img
                              src={data.slider.img1}
                              alt={t("settings.desktop_mode")}
                              className="h-full object-contain"
                            />
                          ) : (
                            <>
                              <Upload className="w-8 h-8 text-[#9e68ba] mb-1" />
                              <span className="text-sm text-gray-500">
                                {t("settings.desktop_mode")}
                              </span>
                            </>
                          )}
                          <input
                            id="slider1"
                            type="file"
                            className="hidden"
                            onChange={handleFileChange2}
                            accept="image/*"
                          />
                        </div>
                        <p className="text-center text-sm text-gray-500 mt-1">
                          {t("settings.desktop_mode")}
                        </p>
                      </div>
                    </div>

                    <div className="flex justify-center items-center">
                      <svg
                        width="180"
                        height="239"
                        viewBox="0 0 180 239"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-48 h-64"
                      >
                        <rect
                          x="1.56572"
                          y="1.38158"
                          width="176.869"
                          height="236.237"
                          rx="10.5132"
                          fill="#F3F3F3"
                          stroke="#E9E9E9"
                          strokeWidth="1.23684"
                        ></rect>
                        <rect
                          x="3.1052"
                          y="2.1052"
                          width="172.7393"
                          height="6.18421"
                          rx="3.09211"
                          fill={data.color1}
                        ></rect>
                        <rect
                          x="78.184"
                          y="13.6055"
                          width="24.7369"
                          height="8.6579"
                          rx="4.32895"
                          fill="#C4C4C4"
                        ></rect>
                        <rect
                          x="10.842"
                          y="194.948"
                          width="18.7393"
                          height="6.18421"
                          rx="3.09211"
                          fill={data.color1}
                        ></rect>
                        <rect
                          x="30.6315"
                          y="194.948"
                          width="18.7393"
                          height="6.18421"
                          rx="3.09211"
                          fill={data.color2}
                        ></rect>
                        <rect
                          x="64.8421"
                          y="28.3159"
                          width="51.1316"
                          height="2.47369"
                          rx="1.23684"
                          fill={data.color1}
                        ></rect>
                        <rect
                          x="134.1578"
                          y="177.3159"
                          width="11.1316"
                          height="2.47369"
                          rx="1.23684"
                          fill={data.color2}
                        ></rect>
                        <rect
                          x="83.1578"
                          y="177.3159"
                          width="11.1316"
                          height="2.47369"
                          rx="1.23684"
                          fill={data.color2}
                        ></rect>
                        <rect
                          x="30.1578"
                          y="177.3159"
                          width="11.1316"
                          height="2.47369"
                          rx="1.23684"
                          fill={data.color2}
                        ></rect>
                        <circle
                          cx="161.6767"
                          cy="225.5525"
                          r="2.47369"
                          fill="#C4C4C4"
                        ></circle>
                        <circle
                          cx="154.6767"
                          cy="225.5525"
                          r="2.47369"
                          fill="#C4C4C4"
                        ></circle>
                        <image
                          x="10.842"
                          y="35.3948"
                          width="157.079"
                          height="81.6316"
                          href={data?.slider?.img1 ? data?.slider?.img1 : ""}
                        />
                        <rect
                          x="80.1052"
                          y="227.105"
                          width="18.5526"
                          height="2.47369"
                          fill="#E9E9E9"
                        ></rect>
                        <rect
                          x="11.2368"
                          y="121.974"
                          width="50"
                          height="63"
                          rx="4.94737"
                          fill="#C4C4C4"
                          fillOpacity="0.5"
                        ></rect>
                        <rect
                          x="118.2368"
                          y="121.974"
                          width="50"
                          height="63"
                          rx="4.94737"
                          fill="#C4C4C4"
                          fillOpacity="0.5"
                        ></rect>
                        <rect
                          x="65.2368"
                          y="121.974"
                          width="50"
                          height="63"
                          rx="4.94737"
                          fill="#C4C4C4"
                          fillOpacity="0.5"
                        ></rect>
                        <circle
                          r="1.57416"
                          transform="matrix(1 0 0 -1 97.0837 111.179)"
                          fill="#C4C4C4"
                        ></circle>
                        <circle
                          r="1.57416"
                          transform="matrix(1 0 0 -1 92.3612 111.179)"
                          fill="#C4C4C4"
                        ></circle>
                        <circle
                          r="1.57416"
                          transform="matrix(1 0 0 -1 87.6387 111.179)"
                          fill="#ffffff"
                        ></circle>
                        <circle
                          r="1.57416"
                          transform="matrix(1 0 0 -1 82.9162 111.179)"
                          fill="#C4C4C4"
                        ></circle>
                      </svg>
                    </div>
                  </div>

                  <div className="flex justify-end mt-4">
                    <AntButton
                      type="primary"
                      onClick={!!account.store ? handleSubmit : message}
                      loading={loading}
                      className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] border-[#bc7ade] text-[#fff] hover:border-purple-700 rounded-lg py-2 px-4 h-auto dark:bg-[#9b59bf] dark:!border-[#3c3a3d] dark:hover:!bg-[#814a9f] dark:transition-colors dark:text-white"
                    >
                      {!loading && <Save size={18} />}
                      <span className="mr-1">
                        {loading
                          ? t("settings.saving")
                          : t("settings.save_changes")}
                      </span>
                    </AntButton>
                  </div>
                </div>

                {/* Footer Section */}
                <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <div className="flex items-center mb-4 gap-x-2">
                    <Type size={20} className="text-[#9e68ba] mr-2" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-[#9e68ba]">
                      {t("settings.footer_text")}
                    </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("settings.footer_text")}
                      </label>
                      <input
                        type="text"
                        placeholder={t("settings.footer_placeholder")}
                        value={data.footer}
                        onChange={(e) =>
                          setData({ ...data, footer: e.target.value })
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#181819] dark:text-gray-400 dark:!border-[#3c3a3d]"
                      />
                      <div className="mt-4">
                        <AntButton
                          type="primary"
                          onClick={!!account.store ? handleSubmit : message}
                          className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-[#fff] border-[#bc7ade] hover:border-purple-700 rounded-lg py-2 px-4 h-auto dark:bg-[#9b59bf] dark:!border-[#3c3a3d] dark:hover:!bg-[#814a9f] dark:transition-colors dark:text-white"
                        >
                          <Save size={18} />
                          <span className="mr-1">
                            {t("settings.save_changes")}
                          </span>
                        </AntButton>
                      </div>
                    </div>

                    <div className="md:col-span-2 flex justify-center items-center">
                      <div className="relative w-full max-w-md h-32 rounded-lg overflow-hidden shadow-md bg-white">
                        <div className="absolute inset-0 flex items-end justify-center text-center pb-4">
                          <p className="text-sm text-gray-600">{data.footer}</p>
                        </div>
                        <div className="absolute bottom-0 left-0 right-0 h-px bg-gray-200"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Categories Tab */}
            {activeTab === "tab2" && data && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <LayoutGrid size={20} className="text-[#9e68ba] mr-2" />
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-[#9e68ba]">
                    {t("settings.categories")}
                  </h3>
                  <span className="text-sm text-gray-500 dark:text-gray-400 mr-3">
                    {t("settings.select_categories")}
                  </span>
                </div>

                {/* Categories principales (5 premières) */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 mb-6">
                  {[0, 1, 2, 3, 4].map((index) => (
                    <div key={index} className="flex flex-col items-center">
                      <div className="relative mb-2">
                        {data.categories[5 + index] && (
                          <button
                            onClick={() => onClickHandler(5 + index)}
                            className="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full p-1 hover:bg-red-200 z-10"
                          >
                            <X size={16} />
                          </button>
                        )}
                        <div
                          onDrop={(e) => handleDrop(e, "cate", 5 + index)}
                          onDragOver={(e) => handleDragOver(e)}
                          onClick={() =>
                            document
                              .getElementById(`imageUpload${5 + index}`)
                              .click()
                          }
                          className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed dark:!border-[#3c3a3d] rounded-xl p-2 cursor-pointer transition-all ${
                            data.categories[5 + index]
                              ? "border-purple-300 bg-[#fcf6ff]"
                              : "border-gray-300 hover:border-[#9b59bf]"
                          }`}
                        >
                          {data.categories[5 + index] ? (
                            <img
                              src={data.categories[5 + index]}
                              alt={t("settings.category_image", {
                                number: index + 1,
                              })}
                              className="h-full object-contain"
                            />
                          ) : (
                            <>
                              <Upload className="w-8 h-8 text-[#9e68ba] mb-1" />
                              <span className="text-sm text-gray-500">
                                {t("settings.category")}
                              </span>
                            </>
                          )}
                          <input
                            id={`imageUpload${5 + index}`}
                            type="file"
                            className="hidden"
                            onChange={(e) =>
                              uploadImage2(
                                [e.target.files[0]],
                                "cate",
                                5 + index
                              )
                            }
                            accept="image/*"
                          />
                        </div>
                      </div>
                      <input
                        type="text"
                        className="w-full px-3 py-2 text-center border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#181819] dark:text-gray-400"
                        value={data.categories[index]}
                        onChange={(e) =>
                          setData({
                            ...data,
                            categories: update(
                              data.categories,
                              e.target.value,
                              index
                            ),
                          })
                        }
                        placeholder={t("settings.category_name_placeholder", {
                          number: index + 1,
                        })}
                      />
                    </div>
                  ))}
                </div>

                {data.categories
                  .slice(0, 5)
                  .every((cat) => cat && cat.trim() !== "") &&
                  data.categories
                    .slice(5, 10)
                    .every((cat) => cat && cat.trim() !== "") && (
                    <div className="flex justify-center mb-6">
                      <button
                        onClick={() => {
                          const newAdditionalCategory = {
                            title: "",
                            image: "",
                          };
                          setData({
                            ...data,
                            additionalCategories: [
                              ...(data.additionalCategories || []),
                              newAdditionalCategory,
                            ],
                          });
                        }}
                        className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white border border-[#bc7ade] hover:border-purple-700 rounded-lg py-2 px-4 transition-all"
                      >
                        <Plus size={18} />
                        <span>{t("ui.addCategory")}</span>
                      </button>
                    </div>
                  )}

                {/* Catégories additionnelles */}
                {data.additionalCategories &&
                  data.additionalCategories.length > 0 && (
                    <div className="border-t border-gray-200 pt-6">
                      <div className="flex items-center mb-4">
                        <LayoutGrid size={18} className="text-[#9e68ba] mr-2" />
                        <h4 className="text-md font-semibold text-gray-800">
                          {t("ui.extraCategories")}
                        </h4>
                      </div>

                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 mb-4">
                        {data.additionalCategories.map((category, index) => (
                          <div
                            key={`additional-${index}`}
                            className="flex flex-col items-center"
                          >
                            <div className="relative mb-2">
                              {category.image && (
                                <button
                                  onClick={() => {
                                    const updatedAdditionalCategories = [
                                      ...data.additionalCategories,
                                    ];
                                    updatedAdditionalCategories[index] = {
                                      ...category,
                                      image: "",
                                    };
                                    setData({
                                      ...data,
                                      additionalCategories:
                                        updatedAdditionalCategories,
                                    });
                                  }}
                                  className="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full p-1 hover:bg-red-200 z-10"
                                >
                                  <X size={16} />
                                </button>
                              )}
                              <div
                                onDrop={(e) => handleDropAdditional(e, index)}
                                onDragOver={(e) => handleDragOver(e)}
                                onClick={() =>
                                  document
                                    .getElementById(
                                      `additionalImageUpload${index}`
                                    )
                                    .click()
                                }
                                className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-xl p-2 cursor-pointer transition-all ${
                                  category.image
                                    ? "border-purple-300 bg-[#fcf6ff]"
                                    : "border-gray-300 hover:border-[#9b59bf]"
                                }`}
                              >
                                {category.image ? (
                                  <img
                                    src={category.image}
                                    alt={t("ui.extraCategoryImage", { value0: (index + 1) })}
                                    className="h-full object-contain"
                                  />
                                ) : (
                                  <>
                                    <Upload className="w-8 h-8 text-[#9e68ba] mb-1" />
                                    <span className="text-sm text-gray-500">
                                      {t("ui.extraCategory")} {index + 1}
                                    </span>
                                  </>
                                )}
                                <input
                                  id={`additionalImageUpload${index}`}
                                  type="file"
                                  className="hidden"
                                  onChange={(e) =>
                                    uploadAdditionalImage(
                                      [e.target.files[0]],
                                      index
                                    )
                                  }
                                  accept="image/*"
                                />
                              </div>
                            </div>
                            <div className="flex items-center w-full gap-2">
                              <input
                                type="text"
                                className="flex-1 px-3 py-2 text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200"
                                value={category.title}
                                onChange={(e) => {
                                  const updatedAdditionalCategories = [
                                    ...data.additionalCategories,
                                  ];
                                  updatedAdditionalCategories[index] = {
                                    ...category,
                                    title: e.target.value,
                                  };
                                  setData({
                                    ...data,
                                    additionalCategories:
                                      updatedAdditionalCategories,
                                  });
                                }}
                                placeholder={t("ui.extraCategoryName", { value0: (index + 1) })}
                              />
                              <button
                                onClick={() => {
                                  // Supprimer la catégorie additionnelle complète
                                  const updatedAdditionalCategories =
                                    data.additionalCategories.filter(
                                      (_, i) => i !== index
                                    );
                                  setData({
                                    ...data,
                                    additionalCategories:
                                      updatedAdditionalCategories,
                                  });
                                }}
                                className="bg-red-100 text-red-600 rounded-full p-1 hover:bg-red-200 transition-all"
                              >
                                <Trash2 size={16} />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                <div className="flex justify-end mt-4">
                  <AntButton
                    type="primary"
                    onClick={!!account.store ? handleSubmit : message}
                    className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-[#fff] border-[#bc7ade] hover:border-purple-700 rounded-lg py-2 px-4 h-auto dark:bg-[#9b59bf] dark:!border-[#3c3a3d] dark:hover:!bg-[#814a9f] dark:transition-colors dark:text-white"
                  >
                    <Save size={18} />
                    <span className="mr-1">{t("settings.save_changes")}</span>
                  </AntButton>
                </div>
              </div>
            )}

            {/* Thank You Page Tab */}
            {activeTab === "tab3" && data && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div
                    className="bg-white dark:!bg-[#141414] rounded-xl p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:shadow-md transition-all cursor-pointer flex flex-col items-center justify-center"
                    onClick={
                      !!account.store
                        ? () =>
                            setShow({
                              model1: true,
                              model2: false,
                              model3: false,
                            })
                        : message
                    }
                  >
                    <CreditCard size={48} className="text-[#9e68ba] mb-3" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-300 mb-1">
                      {t("settings.payment_policy")}
                    </h3>
                    <p className="text-sm text-gray-500 text-center">
                      {t("settings.set_payment_policies")}
                    </p>
                  </div>

                  <div
                    className="bg-white dark:!bg-[#141414] rounded-xl p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:shadow-md transition-all cursor-pointer flex flex-col items-center justify-center"
                    onClick={
                      !!account.store
                        ? () =>
                            setShow({
                              model1: false,
                              model2: true,
                              model3: false,
                            })
                        : message
                    }
                  >
                    <RefreshCw size={48} className="text-[#9e68ba] mb-3" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-300 mb-1">
                      {t("settings.return_policy")}
                    </h3>
                    <p className="text-sm text-gray-500 text-center">
                      {t("settings.set_return_policies")}
                    </p>
                  </div>

                  <div
                    className="bg-white dark:!bg-[#141414] rounded-xl p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:shadow-md transition-all cursor-pointer flex flex-col items-center justify-center"
                    onClick={
                      !!account.store
                        ? () =>
                            setShow({
                              model1: false,
                              model2: false,
                              model3: true,
                            })
                        : message
                    }
                  >
                    <Lightbulb size={48} className="text-[#9e68ba] mb-3" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-300 mb-1">
                      {t("settings.thank_you_page_customization")}
                    </h3>
                    <p className="text-sm text-gray-500 text-center">
                      {t("settings.customize_thank_you_page")}
                    </p>
                  </div>
                </div>
              </div>
            )}
            {/* themes Page Tab */}
            {activeTab === "tab4" && data && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="p-3">
                  <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4">
                    {/* ===== Theme 1 ===== */}
                    <div className="group bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:shadow-md transition-all duration-200 overflow-hidden">
                      {/* Preview Image */}
                      <div className="relative h-80 bg-gradient-to-br from-gray-100 to-gray-200 dark:!from-[#2a2a2a] dark:!to-[#1a1a1a] overflow-hidden">
                        {data.theme === 1 && (
                          <div className="absolute top-3 left-3 z-20">
                            <span className="bg-green-500 text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-lg">
                              ✓
                            </span>
                          </div>
                        )}

                        <img
                          src="/theme/theme1.png"
                          alt={t("themes.theme1_alt")}
                          className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-110"
                        />

                        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-10"></div>

                        <div className="absolute bottom-3 right-3 z-20">
                          <div className="rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-2 w-12 h-12 flex items-center justify-center bg-white dark:!bg-[#2a2a2a] shadow-lg">
                            <span className="text-2xl">🎨</span>
                          </div>
                        </div>
                      </div>

                      {/* Header */}
                      <div className="p-4">
                        <div className="mb-3">
                          <h3 className="font-bold text-xl text-[#9e68ba] dark:!text-[#b48acb] mb-2">
                            {t("themes.classic_theme")}
                          </h3>

                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 dark:!bg-blue-900 text-blue-800 dark:!text-blue-300">
                            {t("themes.suitable_for_all_stores")}
                          </span>
                        </div>

                        <p className="text-gray-600 dark:!text-gray-400 text-sm line-clamp-2">
                          {t("themes.classic_theme_description")}
                        </p>
                      </div>

                      {/* Footer */}
                      <div className="border-t border-[#fbf4ff] dark:!border-[#3c3a3d] p-4 bg-gradient-to-r from-purple-50 to-white dark:!from-[#2a2a2a] dark:!to-[#181819] flex gap-2">
                        <button
                          onClick={() => activateTheme(1)}
                          className="flex-1 bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium"
                        >
                          {data.theme === 1
                            ? t("themes.currently_active")
                            : t("themes.activate_theme")}
                        </button>
                      </div>
                    </div>

                    {/* ===== Theme 2 ===== */}
                    <div className="group bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:shadow-md transition-all duration-200 overflow-hidden">
                      {/* Preview Image */}
                      <div className="relative h-80 bg-gradient-to-br from-gray-100 to-gray-200 dark:!from-[#2a2a2a] dark:!to-[#1a1a1a] overflow-hidden">
                        {data.theme === 2 && (
                          <div className="absolute top-3 left-3 z-20">
                            <span className="bg-green-500 text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-lg">
                              ✓
                            </span>
                          </div>
                        )}

                        <img
                          src="/theme/theme2.png"
                          alt={t("themes.theme2_alt")}
                          className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-110"
                        />

                        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-10"></div>

                        <div className="absolute bottom-3 right-3 z-20">
                          <div className="rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-2 w-12 h-12 flex items-center justify-center bg-white dark:!bg-[#2a2a2a] shadow-lg">
                            <span className="text-2xl">⚡</span>
                          </div>
                        </div>
                      </div>

                      {/* Header */}
                      <div className="p-4">
                        <div className="mb-3">
                          <h3 className="font-bold text-xl text-[#9e68ba] dark:!text-[#b48acb] mb-2">
                            {t("themes.fawry_theme")}
                          </h3>

                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 dark:!bg-yellow-900 text-yellow-800 dark:!text-yellow-300">
                            {t("themes.higher_conversion")}
                          </span>
                        </div>

                        <p className="text-gray-600 dark:!text-gray-400 text-sm line-clamp-2">
                          {t("themes.fawry_theme_description")}
                        </p>
                      </div>

                      {/* Footer */}
                      <div className="border-t border-[#fbf4ff] dark:!border-[#3c3a3d] p-4 bg-gradient-to-r from-purple-50 to-white dark:!from-[#2a2a2a] dark:!to-[#181819] flex gap-2">
                        <button
                          onClick={() => activateTheme(2)}
                          className="flex-1 bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium"
                        >
                          {data.theme === 2
                            ? t("themes.currently_active")
                            : t("themes.activate_theme")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Models */}
            <Model
              show={show.model1}
              setShow={setShow}
              data={data}
              setData={setData}
            />
            <Model2
              show={show.model2}
              setShow={setShow}
              data={data}
              setData={setData}
            />
            <Model3
              show={show.model3}
              setShow={setShow}
              data={data}
              setData={setData}
            />
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Store;
